import { triggerSimpleAjax } from "../../helpers/httpHelper";
import { UPLOAD_OUTLET_IMAGES } from "../../helpers/constants/apiUrl";

/**
 * Upload multiple images for an outlet
 * @param {File[]} files - Array of image files to upload
 * @returns {Promise<string[]>} - Promise that resolves with array of uploaded image IDs
 */
export const uploadOutletImages = (files) => {
    return new Promise((resolve, reject) => {
        if (!files || files.length === 0) {
            reject(new Error('No files provided'));
            return;
        }

        const uploadPromises = files.map(file => {
            return new Promise((res, rej) => {
                const formData = new FormData();
                formData.append('image', file);
                formData.append('name', file.name);

                triggerSimpleAjax(
                    UPLOAD_OUTLET_IMAGES,
                    'POST',
                    formData,
                    (response) => {
                         res(response);
                    },
                    (error) => {
                        rej(error);
                    },
                    {},
                    true
                );
            });
        });

        Promise.all(uploadPromises)
            .then(imageIds => {
                resolve(imageIds);
            })
            .catch(error => {
                reject(error);
            });
    });
};
